<div class="container" #dialog>
    <div class="option-item" *ngFor="let option of data.options" (click)="selectOption(option, $event)">
        <div class="option-row">
            {{ getOptionText(option) | translate }}
        </div>
    </div>
</div>
